import { gql } from '@apollo/client'

export const MARK_CASE_EMAIL_READ_MUTATION = gql`
  mutation markCaseEmailRead($id: ID!, $read: Boolean) {
    markCaseEmailRead(id: $id, read: $read) {
      caseEmail {
        id
        read
        readAt
      }
      errors
    }
  }
`

export const MARK_ALL_CASE_EMAILS_READ_MUTATION = gql`
  mutation markAllCaseEmailsRead($caseId: ID!) {
    markAllCaseEmailsRead(caseId: $caseId) {
      success
      errors
    }
  }
`
